// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__3S1MS","Logo":"Navbar_Logo__3sXzE"};